import * as Sentry from '@sentry/browser';

export default class ErrorTracker {
    constructor() {
        if (!SENTRY_DSN || SENTRY_DSN === '') return;

        Sentry.init({
            denyUrls: [
                /bundles\/fosckeditor\/ckeditor\.js/,
            ],
            dsn: SENTRY_DSN,
            ignoreErrors: ['ResizeObserver loop limit exceeded'], // Stop browser-specific loop alerts cluttering Sentry (they are non-issues)
        });

        $(document).ready(function () {
            if (!Enrola.user) return;

            const {id, email, username} = {...Enrola.user};

            Sentry.setUser({id, email, username});
        });
    }
}
